export default function base64FromBlob (file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()
    // 読み込んだファイルの中身を取得する
    reader.readAsArrayBuffer(file)

    // ファイルの中身を取得後に処理を行う
    reader.addEventListener('load', function () {
      const arrayBuffer = reader.result
      const bytes = new Uint8Array(arrayBuffer)
      const buffer = Buffer.from(bytes)
      console.log(buffer)
      const base64 = buffer.toString('base64')
      resolve(base64)
    })
  })
}
